module.exports = __webpack_public_path__ + "static/img/sdaqgl_xcaqgl_two.9886c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdaqgl_xcaqgl_two.png
// module id = qIQ4
// module chunks = 21